<template>
  <div>
    <button
      ref="language-switcher"
      class="flex items-center tracking-wider uppercase select-none focus:outline-none"
      :class="switcherClasses"
      @click="showAvailableLanguages = !showAvailableLanguages"
    >
      {{ $i18n.locale }}
      <IconFA
        ref="language-switcher-icon"
        :icon="['far', 'angle-down']"
        fixed-width
        class="icon text-2xl ml-5 transform rotate-0 duration-300 ease-in-out-quart"
        :class="{ 'rotate-180': showAvailableLanguages }"
      />
    </button>

    <transition name="zoom-in-top">
      <div
        v-if="showAvailableLanguages"
        class="absolute top-0 right-0 py-8 mt-40 mr-15 cursor-pointer bg-white rounded-md border border-gray-300"
      >
        <div
          v-for="(locale, index) in locales"
          :key="index"
          :class="($i18n.locale === locale) ? 'text-primary' : ''"
          class="relative flex items-center py-8 pl-45 pr-30 cursor-pointer hover:text-primary"
          @click.stop.prevent="changeLocale(locale)"
          @touchend.stop.prevent="changeLocale(locale)"
        >
          <span
            class="tracking-wide"
            :class="{ 'font-semibold': $i18n.locale === locale }"
          >
            {{ $t(`language_display_names.${locale}`) }}
          </span>
          <IconFA
            v-if="$i18n.locale === locale"
            :icon="['far', 'check']"
            class="icon absolute left-0 h-20 text-xl ml-14"
          />
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import { availableLocales } from '@/i18n';


export default {
  props: {
    switcherClasses: {
      type: [Array, String],
    },
  },
  data: () => ({
    showAvailableLanguages: false,
    locales: availableLocales,
  }),
  created() {
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('touchend', this.onDocumentClick);
  },
  methods: {
    changeLocale(locale) {
      this.showAvailableLanguages = false;
      if (this.$i18n.locale !== locale) {
        this.$router.push({ params: { locale } });
      }
    },
    onDocumentClick(event) {
      const languageSwitcher = this.$refs['language-switcher'];
      const languageSwitcherIcon = this.$refs['language-switcher-icon'];
      const targetElement = event.target;

      if ((targetElement !== languageSwitcher) && (targetElement !== languageSwitcherIcon)) {
        this.showAvailableLanguages = false;
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('touchend', this.onDocumentClick);
  },
};
</script>


<style scoped>
.zoom-in-top-enter-active,
.zoom-in-top-leave-active {
  @apply opacity-100;

  transform: scaleY(1);
  transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
  transform-origin: center top;
}
.zoom-in-top-enter,
.zoom-in-top-leave-active {
  @apply opacity-0;

  transform: scaleY(0);
}
.dropdown-arrow-open {
  -webkit-animation: rotation-open 0.5s forwards;
}
@-webkit-keyframes rotation-open {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(180deg);
  }
}
.dropdown-arrow-close {
  -webkit-animation: rotation-close 0.5s forwards;
}
@-webkit-keyframes rotation-close {
  from {
    -webkit-transform: rotate(180deg);
  }
  to {
    -webkit-transform: rotate(0deg);
  }
}
</style>
